export const SAVE_XEROX_CODE = "SAVE_XEROX_CODE";
export const SAVE_XEROX_CODE_SUCCESS = "SAVE_XEROX_CODE_SUCCESS";
export const SAVE_XEROX_CODE_FAIL = "SAVE_XEROX_CODE_FAIL";
